module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-04.61fc9b6f.jpg";